function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "legs");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "legs",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M183.36,400.2539 L137.752,400.2539 C136.11,397.7379 135.185,394.9109 135.185,391.9219 C135.185,381.8169 145.717,373.5599 159.007,372.9589 C152.568,318.1149 163.677,260.3539 164.184,257.7689 C164.821,254.5179 167.976,252.3999 171.225,253.0349 C174.476,253.6719 176.596,256.8239 175.96,260.0759 C175.838,260.7019 164.298,320.7869 171.32,374.7149 C179.949,377.7479 185.927,384.3109 185.927,391.9219 C185.927,394.9109 185.002,397.7379 183.36,400.2539 Z M216.6393,400.2539 C214.9973,397.7379 214.0723,394.9109 214.0723,391.9219 C214.0723,384.3109 220.0503,377.7479 228.6793,374.7149 C235.7013,320.7869 224.1613,260.7019 224.0383,260.0759 C223.4033,256.8239 225.5233,253.6719 228.7753,253.0349 C232.0233,252.3999 235.1783,254.5179 235.8163,257.7689 C236.3223,260.3539 247.4313,318.1149 240.9923,372.9589 C254.2833,373.5599 264.8143,381.8169 264.8143,391.9219 C264.8143,394.9109 263.8903,397.7379 262.2473,400.2539 L216.6393,400.2539 Z",
  fill: "#424242"
}));

var SvgLegs = function SvgLegs(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "400px",
    height: "400px",
    viewBox: "0 0 400 400",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLegs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/legs.1e2d212b.svg";
export { ForwardRef as ReactComponent };